<template>
  <form class="form">
    <div
      class="text-green font-20 d-flex align-items-center"
      style="margin-bottom: 12px"
    >
      <span class="custModifyAgent">服務人員資訊</span>
      <button
        type="button"
        style="vertical-align: middle"
        class="btn btn-default btn-sm"
        @click="doCancel(false)"
      >
        取消
      </button>
      <button
        type="button"
        style="vertical-align: middle"
        class="btn btn-default btn-sm"
        @click="getCustInfo"
      >
        帶入CRM個人資料
      </button>
      <button
        type="button"
        style="vertical-align: middle"
        class="btn btn-default btn-sm"
        @click="doEdit"
      >
        儲存
      </button>
      <span style="color: rgb(222, 64, 84)">(修改完成後請務必點擊儲存)</span>
    </div>

    <div class="text-black mt-2 mb-3 ml-2 d-flex align-items-center">
      <span class="custAgentTitle">保險顧問</span>
      <span class="ml-3">
        <input
          type="text"
          id="agentNm"
          name="agentNm"
          placeholder="姓名"
          v-model="form.agentNm"
          alt="ch"
          @input="checkInputName(form)"
          @blur="checkInputName(form)"
          class="form-control RectangleStyle RectangleWidth-m"
          style="display: inline"
        />
        <span :class="{ 'section-loading': loading_1 }"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
        >
      </span>
    </div>

    <div class="text-black ml-2 d-flex">
      <span class="custAgentTitle" style="line-height: 40px"
        >手機&emsp;&emsp;</span
      >
      <span class="ml-3">
        <input
          type="text"
          id="agentCellPhone"
          name="agentCellPhone"
          placeholder="手機"
          v-validate="'cellphone'"
          :class="{ 'is-invalid': errors.has('agentCellPhone') }"
          v-model="form.agentCellPhone"
          class="form-control RectangleStyle RectangleWidth-m"
          style="display:inline"
          maxlength="10"
          @input="checkInputMobile(form)"
          @blur="checkInputMobile(form)"
        />
        <span :class="{ 'section-loading': loading_1 }"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
        >

        <div v-if="!errors.has('agentCellPhone')">&nbsp;</div>
        <div class="text-danger d-flex" v-if="errors.has('agentCellPhone')">
          {{ errors.first("agentCellPhone") }}
        </div>
      </span>
    </div>
  </form>
</template>

<script>
import { mapGetters } from "vuex";
import { Validator } from "vee-validate";
import {
  queryDistByCity,
  getCustInfo,
  getAgntInfo,
  updateAgntInfo,
} from "@/service";
import { commonMixin } from "@/mixins/common";

Validator.extend("cellphone", {
  getMessage: `手機格式有誤`,
  validate: (value) => {
    if (value == "") {
      return true;
    }
    let mobilePattern = new RegExp("^[0-9]{10}$");
    return mobilePattern.test(value);
  },
});

Validator.extend("areaCode", {
  getMessage: ``,
  validate: (value) => {
    if (value == "") {
      return true;
    }
    let phonePattern = new RegExp("^[0-9]*$");
    return phonePattern.test(value);
  },
});

Validator.extend("compPhone", {
  getMessage: ``,
  validate: (value) => {
    if (value == "") {
      return true;
    }
    let phonePattern = new RegExp("^[0-9]*$");
    return phonePattern.test(value);
  },
});

export default {
  name: "EditAgentInfoFamilyModal",
  mixins: [commonMixin],
  data() {
    return {
      loading_1: false,
      loading_2: false,
      form: {
        agentNm: "",
        agentCellPhone: "",
        agentEmail: "",
        office_phone: ["", ""],
        office_address: ["", "", "", ""],
      },
      officeCityOpt: [],
      officeAreaOpt: [],
    };
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.getAgntInfo();
    this.officeCityOpt = this.Cities.map((item) => item.city);
  },
  computed: {
    ...mapGetters(["Cities"]),
  },
  watch: {
    open: "modalOpen",
  },
  methods: {
    //檢查姓名
    checkInputName(agentData) {
      agentData.agentNm = agentData.agentNm.replace(
        /[<>!@#$^&,."'?%*;()+-/_{}[\]|~`=\\\s]/g,
        ""
      );
      if (this.stringBytes(agentData.agentNm, false, 14) > 14) {
        agentData.agentNm = agentData.agentNm.substring(
          0,
          this.stringBytes(agentData.agentNm, true, 14)
        );
      }
    },
    checkInputMobile(agentData) {
      agentData.agentCellPhone = agentData.agentCellPhone.replace(
        /[<>!@#$^&,."'?%*;()+-/_{}[\]|~`=\\\s]/g,
        ""
      );
    },
    doCancel(updated) {
      this.$emit("close");
      this.$validator.reset();
      if (!updated) {
        this.$toast.info({ title: "取消修改" });
      }
    },
    doEdit() {
      this.$validator.validateAll().then((el) => {
        if (el) {
          this.postUpdate();
        }
      });
    },
    getAgntInfo() {
      this.loading_1 = true;
      getAgntInfo(
        this.$store.state.userInfo.id,
        this.$store.state.userInfo.id
      ).then((result) => {
        if (result.header && result.header.status === "200") {
          this.form.agentNm = result.data.agnt_name;
          this.form.agentCellPhone = result.data.mobile;
          this.form.agentEmail = result.data.email;
          this.form.office_phone[0] = result.data.corp_tel_area;
          this.form.office_phone[1] = result.data.corp_tel;
          this.form.office_address = [
            "",
            result.data.corp_addr1,
            result.data.corp_addr2,
            result.data.corp_addr3,
          ];
          if (this.form.office_address && this.form.office_address[1]) {
            this.changeCity(this.form.office_address[1], false, true);
          }
        }
        this.loading_1 = false;
      });
    },
    getCustInfo() {
      this.loading_1 = true;
      getCustInfo(
        this.$store.state.userInfo.id,
        this.$store.state.userInfo.id,
        this.$store.state.userInfo.id
      ).then((result) => {
        if (result.header && result.header.status === "200") {
          this.form.agentNm = result.body.customer.name;
          this.form.agentCellPhone = result.body.customer.mobile;
          this.form.agentEmail = result.body.customer.email;
          this.form.office_phone[0] = result.body.customer.corp_tel_area;
          this.form.office_phone[1] = result.body.customer.corp_tel;
          this.form.office_address = [
            result.body.customer.corp_addr_zip,
            result.body.customer.corp_addr1,
            result.body.customer.corp_addr2,
            result.body.customer.corp_addr3,
          ];
          if (this.form.office_address && this.form.office_address[1]) {
            this.changeCity(this.form.office_address[1], false, true);
          }
        }
        this.loading_1 = false;
      });
    },
    initData() {
      this.form.agentNm = "";
      this.form.agentCellPhone = "";
      this.form.agentEmail = "";
      this.form.office_phone = ["", ""];
      this.form.office_address = ["", "", "", ""];
    },
    changeCity(key, init = true, isOpen = false) {
      this.loading_2 = true;
      // 取得郵遞區號與分區
      queryDistByCity(this.$store.state.userInfo.id, key).then((result) => {
        if (result) {
          if (
            result.body &&
            result.body.cityAreaList &&
            result.body.cityAreaList.length > 0
          ) {
            if (init) {
              // 初始化清空區域
              this.form.office_address[2] = "";
            }
            //產生區域清單
            this.officeAreaOpt = result.body.cityAreaList.map((item) => {
              return {
                //no: item.ZIPCODE,
                name: item.AREA,
              };
            });
            if (isOpen) {
              //  如果是開啟 modal 設定區域
              if (this.form.office_address[2].trim() == "") {
                this.form.office_address[2] = "";
              }
            }
          } else {
            this.officeAreaOpt = [];
          }
        }
        this.loading_2 = false;
      });
    },
    initAreaData() {
      // 清除郵遞區號跟地址
      this.form.office_address[0] = "";
      this.form.office_address[2] = "";
    },
    //將修改資料寫入DB
    postUpdate() {
      let req = {
        agnt_id: this.$store.state.userInfo.id,
        agnt_name: this.form.agentNm,
        mobile: this.form.agentCellPhone,
        email: this.form.agentEmail,
        corp_tel_area: this.form.office_phone[0],
        corp_tel: this.form.office_phone[1],
        corp_addr1: this.form.office_address[1],
        corp_addr2: this.form.office_address[2],
        corp_addr3: this.form.office_address[3],
        cevnm:"",
        upd_source:"MV"
      };
      updateAgntInfo(this.$store.state.userInfo.id, req).then((result) => {
        if (result.header && result.header.status === "200") {
          this.$emit("setAgentData", this.form);
          this.doCancel(true);
          this.$toast.info({ title: "修改成功" });
          this.$emit("close");
        } else {
          this.$toast.info({ title: "修改失敗" });
          this.$emit("close");
        }
      });
    },
    modalOpen() {
      if (this.open) {
        this.getAgntInfo();
      }
    },
  },
};
</script>
<style scoped>
.modal.fade .modal-body {
  min-height: auto;
}

.RectangleWidth-xs {
  width: 60px;
}

.RectangleWidth-s {
  width: 120px;
}

.RectangleWidth-m {
  width: 205px;
}

.RectangleWidth-l {
  width: 240px;
}

.RectangleWidth-xl {
  width: 472px;
}
.custAgentTitle {
  margin-right: 15px;
  font-family: PingFangTC;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align-last: right;
  color: #323a45;
}
.RectangleStyle {
  height: 40px;
  border-radius: 4px;
  box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, 0.3);
  border: solid 1px #c2c4c7;
  background-color: #ffffff;
}
.custModifyAgent {
  font-family: PingFangTC;
  font-size: 20px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #027a39;
}

.dash {
  margin-top: 11px;
  width: 10px;
  height: 22px;
  font-family: PingFangTC;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #323a45;
}

.editbtn {
  width: 120px;
  height: 40px;
}

.getbtn {
  width: 180px;
  height: 40px;
  margin-bottom: -10px;
}

.editbtnFont {
  width: 100px;
  height: 22px;
  font-family: PingFangTC;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
}

.fontType {
  font-family: PingFangTC;
}
</style>
